import styled from "styled-components";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

const TURBO_V2_PAY_BUTTON_HEIGHT = "52px";

export const DiscountAmount = styled.span(({ theme }) => ({
    textDecoration: "line-through",
    margin: `0 ${theme.spacing.xxSmall} 0 ${theme.spacing.xxxSmall}`,
    color: theme.colors[theme.colorMode].text_inverse_Med_Emphasis,
}));

export const BoltWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
}));

export const BoltText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxxSmall,
    color: theme.colors[theme.colorMode].text_inverse_Med_Emphasis,
    marginLeft: theme.spacing.xxSmall,
}));

export const PayButton = styled(FullWidthButton)<{ isPop?: boolean }>(({ isPop }) => ({
    height: TURBO_V2_PAY_BUTTON_HEIGHT,
    ...(isPop && {
        border: "1px solid #0B1B17",
    }),
}));
